(function() {
  'use strict';

  // Nils 29.10.2026: zuerst alle verfügbaren, danach alle verkauften – nie gemischt.
  // Innerhalb jedes Blocks bleibt die Reihenfolge vom Server (gewählte Sortierung).
  function buildSortedOutput(cards) {
    var inStock = cards.filter(function(c) { return c.getAttribute('data-available') === 'true'; });
    var soldOut = cards.filter(function(c) { return c.getAttribute('data-available') === 'false'; });
    return inStock.concat(soldOut);
  }

  function reorderAndPaginate(grid) {
    var allCards = Array.prototype.slice.call(grid.children).filter(function(el) {
      return el.hasAttribute('data-available');
    });
    if (allCards.length === 0) return;

    var batchSize = parseInt(grid.getAttribute('data-nb-batch-size'), 10) || 24;

    var sorted = buildSortedOutput(allCards);

    var fragment = document.createDocumentFragment();
    sorted.forEach(function(card) { fragment.appendChild(card); });
    grid.appendChild(fragment);

    // Der Server zeigt die obersten Karten schon vor diesem Script (is-revealed).
    // Erst alles zurücksetzen, dann die erste Batch der sortierten Reihenfolge zeigen.
    allCards.forEach(function(c) { c.classList.remove('is-revealed'); });
    var initialReveal = Math.min(batchSize, sorted.length);
    for (var i = 0; i < initialReveal; i++) {
      sorted[i].classList.add('is-revealed');
    }

    var loadMoreBtn = grid.parentNode.querySelector('[data-nb-load-more-trigger]')
                   || document.querySelector('[data-nb-load-more-trigger]');
    if (!loadMoreBtn) return;

    if (initialReveal < sorted.length) {
      loadMoreBtn.style.display = '';
    } else {
      loadMoreBtn.style.display = 'none';
    }

    if (loadMoreBtn.dataset.nbBound) return;
    loadMoreBtn.dataset.nbBound = 'true';

    var revealed = initialReveal;
    loadMoreBtn.addEventListener('click', function() {
      var nextBatch = Math.min(revealed + batchSize, sorted.length);
      for (var k = revealed; k < nextBatch; k++) {
        sorted[k].classList.add('is-revealed');
      }
      revealed = nextBatch;

      if (revealed >= sorted.length) {
        loadMoreBtn.style.display = 'none';
      }
    });
  }

  function init() {
    var grids = document.querySelectorAll('[data-nb-collection-sort]');
    grids.forEach(reorderAndPaginate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
